import { format, formatDistanceToNow } from "date-fns";
import dayjs from "dayjs";
import AmazonLogo from "../assests/Images/amazon.png";
import WalmartLogo from "../assests/Images/walmart.png";
import TargetLogo from "../assests/Images/target.png";
import BestBuyLogo from "../assests/Images/best_buy1.png";
import HomeDepotLogo from "../assests/Images/homedepot1.png";
import KrogerLogo from "../assests/Images/kroger.png";
import WayfairLogo from "../assests/Images/wayfair1.png";

export function formatDateTime(dateString) {
  const date = new Date(dateString);
  const formattedDate = format(date, "MMM d yyyy, h:mm a");

  // Get time difference (e.g., "6 days ago", "1 hour ago")
  const relativeTime = formatDistanceToNow(date, { addSuffix: true });

  return `${formattedDate} (${relativeTime})`;
}

export function formatStripeDateTime (unixTimestamp){
  const timestamp=dayjs.unix(unixTimestamp).format("MMM D, YYYY h:mm A");
  return timestamp;
}

export function formatCurrency(amountInCents, currency = "usd") {
  const amount = amountInCents / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 2,
  }).format(amount);
}

export function getEnv(key, isRequired = false) {
  if (!key) return null;
  if (!(key in process.env)) {
    if (isRequired) throw new Error(`Key not found: ${key}`);
    console.error("Key not found:", key);
  }
  return process.env[key];
}

export function isNum(n) {
  return (
    typeof n === "number" ||
    Object.prototype.toString.call(n) === "[object Number]"
  );
}


export function calculateDueDate (pregnancyDay){
  const today = new Date();
  const daysLeft = 280 - pregnancyDay;
  const dueDate = new Date(today.setDate(today.getDate() + daysLeft));
  return dueDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
};

export const isRealSafari = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;

  const ua = navigator.userAgent;
  const vendor = navigator.vendor;

  const isSafari =
    /Safari/.test(ua) && // Has "Safari"
    !/Chrome|CriOS|FxiOS|OPR|Edg|EdgiOS|Edge/.test(ua) && // Not other browsers
    /Apple/.test(vendor); // Vendor must be Apple

  return isSafari;
};

export const formatNumber = (num) => {
  if (num >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  }
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num?.toString();
};


export const storeMeta = Object.freeze({
  Amazon: { logo: AmazonLogo, color: "#FF9900" },
  Walmart: { logo: WalmartLogo, color: "#0071ce" },
  Target: { logo: TargetLogo, color: "#cc0000" },
  Bestbuy: { logo: BestBuyLogo, color: "#cc0000" },
  BestBuy: { logo: BestBuyLogo, color: "#cc0000" },
  Homedepot: { logo: HomeDepotLogo, color: "#cc0000" },
  HomeDepot: { logo: HomeDepotLogo, color: "#cc0000" },
  Kroger: { logo: KrogerLogo, color: "#cc0000" },
  Wayfair: { logo: WayfairLogo, color: "#cc0000" },
});